// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryItemStyles } from "@conklin/App/Components/Categories/CategoryItem";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

categoryItemStyles.categoryItem = {
    css: css`
        justify-content: space-between;
        flex-direction: column;
        display: flex;
    `,
};
categoryItemStyles.imageWrapper = {
    css: css`
        justify-content: center;
    `,
};
categoryItemStyles.categoryTitle = {
    typographyProps: {
        variant: "h5",
        forwardAs: "p",
        css: css`
            margin-bottom: 0;
            &&& {
                color: ${color("text.link")};
            }
        `,
    },
    css: css`
        justify-content: center;
        margin-top: 8px;
    `,
};
categoryItemStyles.image = {
    css: css`
        width: 204px;
        height: 204px;
        justify-content: center;
        img {
            width: 100%;
            height: auto;
            max-height: 100%;
            object-fit: contain;
        }
    `,
};
